"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfReportSnapshot = instanceOfReportSnapshot;
exports.ReportSnapshotFromJSON = ReportSnapshotFromJSON;
exports.ReportSnapshotFromJSONTyped = ReportSnapshotFromJSONTyped;
exports.ReportSnapshotToJSON = ReportSnapshotToJSON;
/**
 * Check if a given object implements the ReportSnapshot interface.
 */
function instanceOfReportSnapshot(value) {
    if (!('audio_path' in value) || value['audio_path'] === undefined)
        return false;
    if (!('created_at' in value) || value['created_at'] === undefined)
        return false;
    if (!('generation' in value) || value['generation'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('professional_id' in value) || value['professional_id'] === undefined)
        return false;
    if (!('report_id' in value) || value['report_id'] === undefined)
        return false;
    if (!('transcription' in value) || value['transcription'] === undefined)
        return false;
    return true;
}
function ReportSnapshotFromJSON(json) {
    return ReportSnapshotFromJSONTyped(json, false);
}
function ReportSnapshotFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'audio_path': json['audio_path'],
        'created_at': json['created_at'],
        'generation': json['generation'],
        'id': json['id'],
        'professional_id': json['professional_id'],
        'report_id': json['report_id'],
        'transcription': json['transcription'],
    };
}
function ReportSnapshotToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'audio_path': value['audio_path'],
        'created_at': value['created_at'],
        'generation': value['generation'],
        'id': value['id'],
        'professional_id': value['professional_id'],
        'report_id': value['report_id'],
        'transcription': value['transcription'],
    };
}
